import React, { useState } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Button, 
  ToggleButton, 
  ToggleButtonGroup,
  Box,
  Typography 
} from '@mui/material';
import { UPSLabel, FedExLabel, DHLLabel } from './ShippingLabels';
import './LabelPreview.css';

const LabelPreview = ({ open, onClose, formData }) => {
  const [selectedCarrier, setSelectedCarrier] = useState(formData?.carrier || 'UPS');

  const handleCarrierChange = (event, newCarrier) => {
    if (newCarrier !== null) {
      setSelectedCarrier(newCarrier);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const renderLabel = () => {
    const labelData = {
      tracking_number: formData?.tracking_number || '1Z999AA1234567890',
      carrier: selectedCarrier,
      shipper_name: formData?.shipper_name || 'John Doe',
      shipper_address: formData?.shipper_address || '123 Main St',
      shipper_city: formData?.shipper_city || 'New York',
      shipper_state: formData?.shipper_state || 'NY',
      shipper_zip: formData?.shipper_zip || '10001',
      shipper_country: formData?.shipper_country || 'USA',
      consignee_name: formData?.consignee_name || 'Jane Smith',
      consignee_address: formData?.consignee_address || '456 Oak Ave',
      consignee_city: formData?.consignee_city || 'Los Angeles',
      consignee_state: formData?.consignee_state || 'CA',
      consignee_zip: formData?.consignee_zip || '90210',
      consignee_country: formData?.consignee_country || 'USA',
      weight: formData?.weight || '5.0',
      service_type: formData?.service_type || 'Express'
    };

    switch (selectedCarrier) {
      case 'UPS':
        return <UPSLabel data={labelData} />;
      case 'FedEx':
        return <FedExLabel data={labelData} />;
      case 'DHL':
        return <DHLLabel data={labelData} />;
      default:
        return <UPSLabel data={labelData} />;
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        style: {
          minHeight: '80vh',
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Realistic Shipping Label Preview</Typography>
          <Box>
            <Button variant="contained" color="primary" onClick={handlePrint} sx={{ mr: 1 }}>
              Print Label
            </Button>
            <Button onClick={onClose}>Close</Button>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Select Carrier Style:
          </Typography>
          <ToggleButtonGroup
            value={selectedCarrier}
            exclusive
            onChange={handleCarrierChange}
            aria-label="carrier selection"
          >
            <ToggleButton value="UPS" aria-label="UPS">
              UPS
            </ToggleButton>
            <ToggleButton value="FedEx" aria-label="FedEx">
              FedEx
            </ToggleButton>
            <ToggleButton value="DHL" aria-label="DHL">
              DHL
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        
        <Box className="label-preview-container">
          {renderLabel()}
        </Box>

        <Box sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Note:</strong> These labels are designed to closely match real shipping labels for testing purposes only. 
            They are not valid for actual shipping and should not be used for real packages.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LabelPreview; 